import { render, staticRenderFns } from "./JewelHistoryPanel.vue?vue&type=template&id=24dacaf7&scoped=true&"
import script from "./JewelHistoryPanel.vue?vue&type=script&lang=js&"
export * from "./JewelHistoryPanel.vue?vue&type=script&lang=js&"
import style0 from "./JewelHistoryPanel.vue?vue&type=style&index=0&id=24dacaf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dacaf7",
  null
  
)

export default component.exports